/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAlertType {
    MONITORING = 'MONITORING',
    SCREENING = 'SCREENING',
    BRIDGE = 'BRIDGE',
    MANUAL = 'MANUAL'
}


export function instanceOfInternalApiAlertType(value: any): boolean {
    for (const key in InternalApiAlertType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAlertType, key)) {
            if (InternalApiAlertType[key as keyof typeof InternalApiAlertType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAlertTypeFromJSON(json: any): InternalApiAlertType {
    return InternalApiAlertTypeFromJSONTyped(json, false);
}

export function InternalApiAlertTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertType {
    return json as InternalApiAlertType;
}

export function InternalApiAlertTypeToJSON(value?: InternalApiAlertType | null): any {
    return value as any;
}

export function InternalApiAlertTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAlertType {
    return value as InternalApiAlertType;
}

